import { css, cx } from '@repo/pandacss/styled-system/css';

const textStyles = css({
  backgroundColor: 'transparent',
  color: 'blue.main',
  textStyle: 'textExtraSmall',
  letterSpacing: 'normal',
  _hover: {
    textDecorationLine: 'underline',
  },
});

type AdvertiserDisclosureTextProps = {
  className?: string;
};

export function AdvertiserDisclosureText({ className }: AdvertiserDisclosureTextProps) {
  return <span className={cx(textStyles, className)}>Advertiser disclosure</span>;
}
